export default __webpack_public_path__ + "static/media/djinn.2aa3949f.png";